import React from 'react';
import DateRangeFilter from 'components/list/Filters/types/DateRangeFilter';

const CancelledAtFilter = <DateRangeFilter
    label='filters.components.cancelledAt.label'
    floatingLabelFixed={ true }
    fullWidth={ true }
    labelText='filters.components.cancelledAt.placeholder'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
    source='cancelled_at'
/>;

export default CancelledAtFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/CancelledAtFilter.js